import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_MUTATION_KEY,
  WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_URL,
  WITHDRAWALS_HISTORY_PERMISSIONS,
} from '../constants';

export default function useDownloadWithdrawalsHistoryReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      WITHDRAWALS_HISTORY_DOWNLOAD_REPORT_URL,
      payload,
      { permission: WITHDRAWALS_HISTORY_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
